<template>
  <component :is="projectName" v-if="projectName" />
</template>

<script>
import { mapGetters } from "vuex";
import kyber from "./kyber";
import skale from "./skale";
import celer from "./celer";
import thegraph from "./thegraph";
import tendermint from "./tendermint";
import solana from "./solana";
import sui from "./sui";

export default {
  components: {
    kyber,
    skale,
    celer,
    thegraph,
    solana,
    sui,
    tendermint,
  },
  computed: mapGetters({
    projects: "projectConfig/projects",
  }),
  data: () => ({
    projectName: "",
  }),
  methods: {
    setupProject() {
      const projectName =
        this.$route.params.projectName ||
        this.$route.path.split("/").slice(-1)[0];
      const project = this.projects.find(
        item =>
          item.implemented &&
          (item.name === projectName || item.projectName === projectName)
      );
      if (!project) return this.$router.push({ name: "Home" });
      this.$store.dispatch("projectConfig/setCurrentProject", project);
      this.$store.dispatch("stakeUtils/setProjectUtils", project.name);
      if (
        project.config.network === "ethereum" ||
        project.config.network === "sui" ||
        project.config.network === "solana"
      ) {
        this.projectName = projectName;
      } else {
        this.projectName = "tendermint";
      }
    },
  },
  mounted() {
    this.setupProject();
  },
  watch: {
    $route() {
      this.setupProject();
    },
  },
};
</script>
